import { render, staticRenderFns } from "./StoreOrder.vue?vue&type=template&id=c4b08b0a&scoped=true"
import script from "./StoreOrder.vue?vue&type=script&lang=js"
export * from "./StoreOrder.vue?vue&type=script&lang=js"
import style0 from "./StoreOrder.vue?vue&type=style&index=0&id=c4b08b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b08b0a",
  null
  
)

export default component.exports